import React from 'react';

const WidgetSummary = props => {
  const {
    bsStyle,
    icon_class,
    CustomComponent,
    title,
    body,
  } = props;
  
  return (
    <section className={`panel panel-featured-left panel-featured-${bsStyle}`}>
      <div className='panel-body widget-container'>
        <div className='widget-summary'>
          <div className='widget-summary-col widget-summary-col-icon'>
            <div className={`summary-icon bg-${bsStyle}`}>
              <i className={icon_class}></i>
            </div>
          </div>
          <div className='widget-summary-col'>
            {CustomComponent || (
              <div className='summary'>
                <h4 className='title dashboard-overview-titles'>{title}</h4>
                <div className='info'>
                  <strong>{body}</strong>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default WidgetSummary;



// WEBPACK FOOTER //
// ./src/browser/components/ui/widget-summary.js